// frontend/src/pages/RiskReview.jsx (REPLACE ENTIRE FILE)
import React from "react";
import ErrorBoundary from "../components/ErrorBoundary.jsx";
import { useReviewForm } from "../hooks/useReviewForm";
import ReviewFormComponent from "../components/ReviewFormComponent";

export default function RiskReview() {
  const formProps = useReviewForm(); // No reviewId = create mode

  return (
    <ErrorBoundary componentName="RiskReviewPage">
      <ReviewFormComponent {...formProps} title="Client Risk Review" />
    </ErrorBoundary>
  );
}
